import React from 'react';
import { motion } from 'framer-motion';
import { FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      content: (
        <div className="footer-about" style={{ textAlign: 'center' }}>
          <div className="footer-logo" style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center' }}>
            <img
              src={require('../assets/LogoPrincipal_NomeBranco.png')}
              alt="Logo MicroCodie"
              style={{ width: 120, height: 'auto', display: 'block', margin: '0 auto' }}
              loading="lazy"
            />
          </div>
          <p>
            Desenvolvimento de software sob medida para o seu negócio.
          </p>
          <div className="footer-slogan">
            <strong>"Construindo pontes entre sua ideia e a solução."</strong>
          </div>
        </div>
      )
    },
    {
      title: "Serviços",
      links: [
        { name: "Desenvolvimento sob demanda", href: "/servicos/desenvolvimento-sistemas", external: true },
        { name: "Criação de sites", href: "/servicos/criacao-sites", external: true },
        { name: "Prototipação", href: "/servicos/prototipacao", external: true },
        { name: "Consultorias", href: "/servicos/consultorias", external: true },
      ]
    },
    {
      title: "Soluções",
      links: [
        { name: "Aplicativo de coleta de dados", href: "#", external: true },
        { name: "Sistema de avaliação", href: "#", external: true },
        { name: "Gestão operacional", href: "#", external: true }
      ]
    },
    {
      title: "Contato",
      content: (
        <div className="footer-contact">
          <div className="contact-item">
            <span>contato@microcodie.com.br</span>
          </div>
          <div className="contact-item">
            <span>(31) 99517-0464</span>
          </div>
          <div className="footer-social">
            <a href="https://instagram.com/microcodie" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/company/microcodiesoftware/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
            <a href="https://www.youtube.com/@Microcodie_" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
            </a>
          </div>
        </div>
      )
    }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            {footerSections.map((section, index) => (
              <motion.div
                key={index}
                className="footer-section"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <h3 className="footer-title">{section.title}</h3>
                
                {section.links ? (
                  <ul className="footer-links">
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        {link.external ? (
                          <a 
                            href={link.href} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="footer-link"
                          >
                            {link.name}
                          </a>
                        ) : (
                          <button 
                            onClick={() => scrollToSection(link.href.replace('#', ''))}
                            className="footer-link"
                          >
                            {link.name}
                          </button>
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  section.content
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} MicroCodie. Todos os direitos reservados.</p>
            <div className="footer-bottom-links">
              <a href="/politica-privacidade">Política de Privacidade</a>
              <span className="separator">|</span>
              <a href="/termos-uso">Termos de Uso</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 